<template>
  <QIcon
    class="cursor-pointer sai-information-popup"
    :name="icon"
    :size="iconSize"
    :color="iconColor"
  >
    <QPopupProxy
      ref="popupProxy"
      breakpoint="0"
      max-width="345px"
      :content-class="[`bdr-a-${popupBorderColor}`]"
    >
      <QBanner
        :class="[`column q-pa-sm bg-${popupColor} text-${popupTextColor}`]"
      >
        <div class="row justify-end">
          <SAIIconBtn @click="hidePopup" :color="popupCloseColor" />
        </div>
        <slot />
      </QBanner>
    </QPopupProxy>
  </QIcon>
</template>

<script>
import { QIcon, QPopupProxy, QBanner } from 'quasar';

export default {
  name: 'SAIInformationPopup',
  props: {
    icon: {
      type: String,
      default: 'eva-info-outline'
    },
    iconColor: {
      type: String,
      default: 'grey-8'
    },
    iconSize: {
      type: String,
      default: '20px'
    },
    popupColor: {
      type: String,
      default: 'application-primary'
    },
    popupTextColor: {
      type: String,
      default: 'white'
    },
    popupCloseColor: {
      type: String,
      default: 'white'
    },
    popupBorderColor: {
      type: String,
      default: 'none'
    }
  },
  methods: {
    hidePopup() {
      if (this.$refs.popupProxy) {
        this.$refs.popupProxy.hide();
      }
    }
  },
  components: {
    QIcon,
    QPopupProxy,
    QBanner,
    SAIIconBtn: () => import('../../atom/sai-icon-btn')
  }
};
</script>

<style lang="sass" scoped>
.sai-information-popup::v-deep
 .q-menu
    border: none
</style>
